import BRANDS from '@chama/utils/constants/brands';

const createProduct = ({ brand, price }) => ({
  brand,
  id: `GASP13-${brand}`,
  price,
  type: 'GASP13',
});

export function checkIfMultimarcas({ representativeBrand }) {
  return representativeBrand === 'MULTIMARCAS';
}

export function checkIfDealerCanAddProducts({ products, isMultimarcas }) {
  // FALSE if dealer has all products
  if (products.length === BRANDS.length) return false;
  // TRUE if dealer is multimarcas
  if (isMultimarcas) return true;
  // TRUE if dealer has 0 products
  if (products.length === 0) return true;
  // defaults to FALSE
  return false;
}

export function checkIfDealerCanDeleteProducts({ products, isMultimarcas }) {
  // TRUE if dealer is multimarcas and owns more than one product
  if (isMultimarcas && products.length > 1) return true;
  // defaults to FALSE
  return false;
}

export function removeProductFromProducts({ products, brand }) {
  // remove product (by product's brand) from dealer products
  return products.filter(product => {
    return product.brand !== brand;
  });
}

export function addProductToProducts({ products, product }) {
  // adding product to products array
  return [...products, createProduct(product)];
}

export function updateProducts({ products, update }) {
  // changing initial products array based on updates
  return products.map(product => ({
    ...product,
    price: update[product.brand],
  }));
}

export function getAvailableBrands({ products, isMultimarcas, representativeBrand }) {
  // get list of dealer's brands
  const dealerBrands = products.map(product => product.brand);
  // if dealer has no products and not multimarcas
  // return only allowed brand
  if (!dealerBrands.length && !isMultimarcas) {
    return [representativeBrand];
  }
  // return only brands that dealer don't have
  return BRANDS.filter(brand => !dealerBrands.includes(brand));
}

export function validatePrice({ price }) {
  if (price > 200 || price < 5) return false;
  return true;
}



// WEBPACK FOOTER //
// ../ui-components/components/DealerProducts/DealerProductsLogic.js